import Swal from 'sweetalert2';
import i18next from 'i18next';

const showConfirmation = ({ 
  title, 
  text, 
  icon, 
  onConfirm, 
  confirmButtonText, 
  cancelButtonText, 
  confirmButtonColor, 
  cancelButtonColor 
}) => {
  Swal.fire({
    title: title ||  i18next.t('defaultConfirmTitle'),
    text: text || '',
    // icon: icon || 'warning',
    showCancelButton: true,
    confirmButtonText: confirmButtonText || i18next.t('defaultConfirmButton'),
    cancelButtonText: cancelButtonText || i18next.t('cancel'),
    reverseButtons: false,
    confirmButtonColor: confirmButtonColor || '#DC3545',
    cancelButtonColor: cancelButtonColor || '#555555',
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};

// Delete
const showDeleteConfirmation = (onConfirm) => {
  showConfirmation({
    title: i18next.t('deleteConfirmationTitle'),
    // icon: 'warning',
    confirmButtonText: i18next.t('yesDelete'),
    cancelButtonText: i18next.t('cancel'),
    confirmButtonColor: '#DC3545',
    onConfirm: onConfirm,
    reverseButtons: false,
  });
};

// Submit
const showSubmitConfirmation = (onConfirm) => {
  showConfirmation({
    title: i18next.t('submitConfirmationTitle'),
    // icon: 'question',
    confirmButtonText: i18next.t('yesSubmit'),
    cancelButtonText: i18next.t('cancel'),
    confirmButtonColor: '#DC3545',
    onConfirm: onConfirm,
    reverseButtons: false,
  });
};

// Navigate
const showNavigateConfirmation = (onConfirm) => {
  showConfirmation({
    title: i18next.t('navigateConfirmationTitle'),
    text: i18next.t('navigateWarning'),
    // icon: 'info',
    confirmButtonText: i18next.t('yesNavigate'),
    cancelButtonText: i18next.t('cancel'),
    confirmButtonColor: '#DC3545',
    onConfirm: onConfirm,
    reverseButtons: false,
  });
};
const showWarningConfirmation = (onConfirm) => {
  showConfirmation({
    title: i18next.t('warningTitle'),
    text: i18next.t('warningText'),
    // icon: 'info',
    confirmButtonText: i18next.t('yes'),
    cancelButtonText:i18next.t('no'),
    confirmButtonColor: '#DC3545',
    onConfirm: onConfirm,
    reverseButtons: false,
  });
};

export { showDeleteConfirmation, showSubmitConfirmation,showWarningConfirmation, showNavigateConfirmation };
